'use client';
import React, { createContext } from 'react';

import { ActiveTests } from '../types';

export type VariantsApiResponseRecord = {
    variantTestName: string;
    variant: string;
};

// Required for the dev drawer UI tool.
export type ExperimentType = {
    experimentKey: string;
    variantsList: string[];
    userVariant: string | null;
    userId: string | null | undefined;
    isTracked?: boolean;
};

// The only slice consumers (useExperimentAuthorization, the route-change-clear
// effect, bfcache restore) actually mutate — everything else in
// ExperimentsStateType is derived straight from useVariantsApiResponse each render.
export type MutableExperimentsState = {
    experimentsListForUiTool: ExperimentType[];
    experimentsListForTracking: ActiveTests;
    // Bumped on bfcache restore to re-run useExperimentAuthorization, since thaw skips mount.
    bfcacheRestoreCount: number;
};

export type ExperimentsStateType = {
    isLoading: boolean;
    userId: string | null | undefined;
    isKid: boolean;
    variantsApiResponse: VariantsApiResponseRecord[];
} & MutableExperimentsState;

type ContextType = {
    state: ExperimentsStateType;
    setState: React.Dispatch<React.SetStateAction<MutableExperimentsState>>;
};

// Default is `null` so useABTestExperimentsContext can throw when miswired outside
// ABTestExperimentsProvider, rather than silently returning a default AB state.
export const ABTestExperimentsContext = createContext<ContextType | null>(null);
